<template>
  <section class="secForm">
    <div class="mask" v-if="showModal" @click="hideAllModals"></div>
    <me-loading :loading="loading"></me-loading>

    <div class="container sign-up">
      <div v-if="step === 0">
        <div class="lead-form__cards-outer-container">
          <header-lead></header-lead>
        </div>
        <form action="javascript:;" class="form">
          <form-lead @getRegistredLead="getRegistredLead"></form-lead>
        </form>
      </div>

      <div v-if="step >= 1">
        <stepper v-if="step <= 3" :currentStep="step"></stepper>

        <div class="signup">
          <form action="javascript:;" class="form">
            <template v-if="currentForm">
              <component
                :is="currentForm"
                :me="me"
                :leadInfo="leadInfo"
                @scrollPageTop="scrollPageTop()"
              ></component>
            </template>

            <template v-else>
              <div class="signup__step signup__step--complete">
                <transition name="fade">
                  <div v-if="step === 7 && me.email">
                    <sign-up-complete
                      @confirm="confirm()"
                      :email="me.email"
                    ></sign-up-complete>
                  </div>
                </transition>
              </div>
            </template>
          </form>
        </div>
      </div>

      <!-- error modal -->
      <transition name="fade">
        <modal-base
          v-if="error"
          title='Atenção!'
          class="lead-form__error-modal"
        >
          <template v-slot:close-icon>
            <svg @click.prevent='closeErroModal()' class='modal__close-icon'>
              <use xlink:href='/images/svg-symbols.svg#close' />
            </svg>
          </template>
          <template v-slot:content>
            <p style="text-align: center !important">
              Ops! Ocorreu um erro no seu cadastro. <br>
              {{
                error
                  ? error
                  : "Por favor, verifique suas informações."
              }}
            </p>
          </template>
          <template v-slot:footer>
            <button class="button button--primary" @click.prevent="closeErroModal()">
              Tentar novamente
            </button>
          </template>
        </modal-base>
      </transition>
    </div>
  </section>
</template>

<script>
import { mapActions } from "vuex";
import cache from "commons/js/libs/cache";
import ModalBase from "commons/js/components/atoms/ModalBase.vue";
import SignUpComplete from "./new-signup/SignUpComplete.vue";
import Stepper from "./new-signup/Stepper.vue";
import HeaderLead from "./new-signup/HeaderLead.vue";
import Lead from "./new-signup/Lead.vue";
import Personal from "./new-signup/Personal.vue";
import Company from "./new-signup/Company.vue";
import OnlineSelling from "./new-signup/OnlineSelling.vue";
import ConfirmationMail from "./new-signup/ConfirmationMail.vue";
import ConfirmationPhone from "./new-signup/ConfirmationPhone.vue";

export default {
  components: {
    ModalBase,
    SignUpComplete,
    Stepper,
    "header-lead": HeaderLead,
    "form-lead": Lead,
    "form-personal": Personal,
    "form-company": Company,
    "form-online-selling": OnlineSelling,
    "form-confirmation-mail": ConfirmationMail,
    "form-confirmation-phone": ConfirmationPhone
  },

  props: {
    firstname: {
      type: String,
      required: false,
    },
    lastname: {
      type: String,
      required: false,
    },
    email: {
      type: String,
      required: false,
    },
    commissioned: {
      type: String,
      required: false,
    },
    state: {
      type: String,
      required: false,
    },
    error: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      step: 0,

      me: {},

      loading: false,

      showModal: false,

      steps: [
        "form-lead",
        "form-personal",
        "form-company",
        "form-online-selling",
        "form-confirmation-mail",
        "form-confirmation-phone"
      ],

      currentForm: "",

      leadInfo: {
        name: "",
        email: "",
      },

      hideBanner: false,
    };
  },

  created() {
    location.hash = "";
    if (this.state) {
      this.step = parseInt(this.state);
      if (this.step > 1) {
        this.loadMe();
      }
      this.go();
    }

    if (this.error) {
      this.showModal = true;
    }
  },
  watch: {
    step() {
      if (this.step > 3) {
        this.setSignupBanner(false);
      }
      if (this.step === 7 && window.location.href.endsWith("/cadastre-se")) {
        window.location.href = "/cadastre-se/boas-vindas";
      }
    },
  },
  methods: {
    ...mapActions("signup", ["setSignupBanner"]),

    loadMe() {
      return axios.get("/api/v2/me").then((response) => {
        if (response.data) {
          this.me = response.data;
        }
      });
    },
    //move on to the next step
    next(steps = 1) {
      this.step += steps;
      // Caso esteja em ambiente sandbox, pulas os passos de validação
      if (MEConfig.get('app.env') === 'sandbox' && this.step > 2) {
        this.step = 7;
      }
      this.go();
    },
    go() {
      if (this.step <= this.steps.length) {
        this.currentForm = this.steps[this.step];
      } else {
        this.currentForm = "";
      }
      this.tracking();
    },
    tracking() {
      if (MEConfig.get('app.env') !== 'production') {
        return;
      }

      if (this.step > 5) {
        try {
          cache.forever("ME-ads-complete-registration", function () {
            gtag("event", "conversion", {
              send_to: "AW-944661966/7MBhCMOYjM0BEM7LucID",
            });
            return 1;
          });
        } catch (e) {
          console.error(e);
        }

        try {
          cache.forever("ME-fb-complete-registration", function () {
            fbq("track", "CompleteRegistration");
            return 1;
          });
        } catch (e) {
          console.error(e);
        }

        return;
      }
      if (this.step > 1) {
        try {
          cache.forever("ME-ads-simple-registration", function () {
            gtag("event", "conversion", {
              send_to: "AW-944661966/EXwcCLmyxMIBEM7LucID",
            });
            return 1;
          });
        } catch (e) {
          console.error(e);
        }

        try {
          cache.forever("ME-fb-simple-registration", function () {
            fbq("track", "SimpleRegistration");
            return 1;
          });
        } catch (e) {
          console.error(e);
        }
      }
    },
    confirm() {
      gtag("event", "sign_up", {
        event_category: "cadastro",
        event_action: "clique",
        event_label: "cadastrar",
      });
    },
    closeErroModal() {
      this.error = "";
      this.showModal = false;
    },
    hideAllModals() {
      this.showModal = false;
      for (let i = 0, length = this.$children.length; i < length; i++) {
        let children = this.$children[i];
        if (this.steps.indexOf(children.$options._componentTag) >= 0) {
          children.hideAllModals();
        }
      }
    },
    getRegistredLead(lead) {
      this.leadInfo.name = lead.name;
      this.leadInfo.email = lead.email;
    },
    scrollPageTop(){
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
@media screen and (min-width  320px) and (max-width 767px)
  >>> .form
    .formLine
      &.error
          padding-bottom 15px
</style>
